import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmt, elapsedOf } from "@/pages/CoachPizarra";

// Tarjetas de partidos en vivo del club (pizarras activas de los entrenadores).
export const LiveNow = () => {
  const [live, setLive] = useState([]);
  const [teams, setTeams] = useState([]);
  const [, setTick] = useState(0);
  const iv = useRef(null);

  useEffect(() => {
    api.get("/teams").then((r) => setTeams(r.data)).catch(() => {});
    const load = async () => {
      try { const r = await api.get("/pizarra/live"); setLive(r.data || []); } catch { /* noop */ }
    };
    load();
    iv.current = setInterval(load, 10000);
    const clock = setInterval(() => setTick((t) => t + 1), 1000);
    return () => { clearInterval(iv.current); clearInterval(clock); };
  }, []);

  if (live.length === 0) return null;
  const teamName = (id) => teams.find((t) => t.id === id)?.name || "Equipo";

  return (
    <div className="mb-8" data-testid="live-now-section">
      <div className="overline mb-2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse inline-block" /> En directo ahora
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {live.map((m) => (
          <Link key={m.user_id} to={`/live/${m.user_id}`} data-testid={`live-card-${m.user_id}`}
            className="border-2 border-red-500/60 bg-red-500/5 p-4 flex items-center justify-between gap-3 hover:border-red-500 transition-colors">
            <div className="min-w-0">
              <div className="font-heading font-black text-sm uppercase truncate">
                {teamName(m.team_id)} <span className="text-muted-foreground">vs</span> {m.opponent}
              </div>
              <div className="text-[11px] text-muted-foreground mt-0.5 truncate">
                {m.user_name || "Entrenador"} · {m.modality} · min {fmt(elapsedOf(m.clock || { running: false, accSec: 0 }))}
              </div>
            </div>
            <div className="font-heading font-black text-3xl tabular-nums flex-shrink-0">{m.goals_us}-{m.goals_them}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};
